/* eslint-disable max-len */
import { LANGUAGE_ENGLISH, LANGUAGE_ENGLISH_MURABAHA } from '../../utils/constants';

const IDS = {
  HELMET_AUTOPAY_PAGETITLE_CANCELLATION: 'payments.helmet.autopay.pageTitle.cancellation',
  HELMET_AUTOPAY_PAGETITLE_CONFIRMATION: 'payments.helmet.autopay.pageTitle.confirmation',
  HELMET_AUTOPAY_PAGETITLE_EDIT: 'payments.helmet.autopay.pageTitle.edit',
  HELMET_AUTOPAY_PAGETITLE_ERROR: 'payments.helmet.autopay.pageTitle.error',
  HELMET_AUTOPAY_PAGETITLE_REVIEW: 'payments.helmet.autopay.pageTitle.review',
  HELMET_AUTOPAY_PAGETITLE_SETUP: 'payments.helmet.autopay.pageTitle.setup',
  HELMET_AUTOPAY_PAGETITLE_TERMS: 'payments.helmet.autopay.pageTitle.terms',
  HELMET_AUTOPAY_PAGETITLE_UNENROLLMENT: 'payments.helmet.autopay.pageTitle.unenrollment',
  HELMET_FLEXDRAFT_PAGETITLE_CONFIRMATION_EDIT: 'payments.helmet.flexdraft.pageTitle.confirmation.edit',
  HELMET_FLEXDRAFT_PAGETITLE_CONFIRMATION_SETUP: 'payments.helmet.flexdraft.pageTitle.confirmation',
  HELMET_FLEXDRAFT_PAGETITLE_EDIT: 'payments.helmet.flexdraft.pageTitle.edit',
  HELMET_FLEXDRAFT_PAGETITLE_ERROR: 'payments.helmet.flexdraft.pageTitle.error',
  HELMET_FLEXDRAFT_PAGETITLE_REVIEW: 'payments.helmet.flexdraft.pageTitle.review',
  HELMET_FLEXDRAFT_PAGETITLE_SETUP: 'payments.helmet.flexdraft.pageTitle.schedule',
  HELMET_FLEXDRAFT_PAGETITLE_TERMS: 'payments.helmet.flexdraft.pageTitle.terms',
  HELMET_ONETIMEPAYMENT_PAGETITLE_CANCELLATION: 'payments.helmet.oneTimePayment.pageTitle.cancellation',
  HELMET_ONETIMEPAYMENT_PAGETITLE_CONFIRMATION: 'payments.helmet.oneTimePayment.pageTitle.confirmation',
  HELMET_ONETIMEPAYMENT_PAGETITLE_ERROR: 'payments.helmet.oneTimePayment.pageTitle.error',
  HELMET_ONETIMEPAYMENT_PAGETITLE_REVIEW: 'payments.helmet.oneTimePayment.pageTitle.review',
  HELMET_ONETIMEPAYMENT_PAGETITLE_SCHEDULE: 'payments.helmet.oneTimePayment.pageTitle.schedule',
  HELMET_ONETIMEPAYMENT_PAGETITLE_TERMS: 'payments.helmet.oneTimePayment.pageTitle.terms',
  HELMET_PAYMENTHISTORY_PAGETITLE: 'payments.helmet.paymentsHistory.pageTitle',
  HELMET_PAYMENTHISTORY_PAGETITLE_ERROR: 'payments.helmet.paymentsHistory.pageTitle.error',
  HELMET_PAYMENTS_PAGETITLE_ERROR: 'payments.helmet.pageTitle.error',
  HELMET_SECTIONTITLE_DASHBOARD: 'payments.helmet.sectionTitle.dashboard',
  HELMET_SECTIONTITLE_PAYMENTS: 'payments.helmet.sectionTitle.payments',
  HELMET_SECTIONTITLE_SPLASH: 'payments.helmet.sectionTitle.splash',
  HOME_CARD_LOAN: 'payments.home.card.loan',
  SPLASHPAGE_AUTOPAY_BUTTON_LABEL: 'payments.splash.autopay.button.label',
  SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT: 'payments.splash.autopay.text.abilityToRemit',
  SPLASHPAGE_AUTOPAY_TEXT_ELIMINATESRISKS: 'payments.splash.autopay.text.eliminatesRisks',
  SPLASHPAGE_AUTOPAY_TEXT_ENVIRONMENTALLYFRIENDLY: 'payments.splash.autopay.text.environmentallyFriendly',
  SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS: 'payments.splash.autopay.text.mortgagePayments',
  SPLASHPAGE_AUTOPAY_TITLE: 'payments.splash.autopay.title',
  SPLASHPAGE_FLEXDRAFT_TEXT_ABILITYTOREMIT: 'payments.splash.flexdraft.text.abilityToRemit',
  SPLASHPAGE_FLEXDRAFT_TEXT_DESIGNATEUPTO: 'payments.splash.flexdraft.text.designateUpto',
  SPLASHPAGE_FLEXDRAFT_TEXT_MORTGAGEPAYMENTS: 'payments.splash.flexdraft.text.mortgagePayments',
};

const enMessages = {
  // Helmet Page Titles Autopay
  [IDS.HELMET_AUTOPAY_PAGETITLE_CANCELLATION]: 'Autopay Request Cancellation Confirmation',
  [IDS.HELMET_AUTOPAY_PAGETITLE_CONFIRMATION]: 'Autopay Request Confirmation',
  [IDS.HELMET_AUTOPAY_PAGETITLE_EDIT]: 'Edit Autopay',
  [IDS.HELMET_AUTOPAY_PAGETITLE_ERROR]: 'Autopay Error',
  [IDS.HELMET_AUTOPAY_PAGETITLE_REVIEW]: 'Review Autopay Request',
  [IDS.HELMET_AUTOPAY_PAGETITLE_SETUP]: 'Set Up Autopay',
  [IDS.HELMET_AUTOPAY_PAGETITLE_TERMS]: 'Automatic Payment Terms & Conditions',
  [IDS.HELMET_AUTOPAY_PAGETITLE_UNENROLLMENT]: 'Autopay Unenrollment Request Confirmation',
  // Helmet Page Titles FlexDraft
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_CONFIRMATION_EDIT]: 'Edit Flexible Drafting Request Confirmation',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_CONFIRMATION_SETUP]: 'Flexible Drafting Enrollment Request Confirmation',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_EDIT]: 'Edit Flexible Drafting',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_ERROR]: 'Flexible Drafting Error',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_REVIEW]: 'Review Flexible Drafting Settings',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_SETUP]: 'Set Up Flexible Drafting',
  [IDS.HELMET_FLEXDRAFT_PAGETITLE_TERMS]: 'Flexible Drafting Terms & Conditions',
  // Helmet Page Titles One-Time Payment
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_CANCELLATION]: 'One-Time Payment Cancellation Confirmation',
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_CONFIRMATION]: 'One-Time Payment Confirmation',
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_ERROR]: 'One-Time Payment Error',
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_REVIEW]: 'Review One-Time Payment Details',
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_SCHEDULE]: 'Schedule One-Time Payment',
  [IDS.HELMET_ONETIMEPAYMENT_PAGETITLE_TERMS]: 'One-Time Payment Terms & Conditions',
  // Helmet Page Titles Payment History
  [IDS.HELMET_PAYMENTHISTORY_PAGETITLE]: 'Payment History',
  [IDS.HELMET_PAYMENTHISTORY_PAGETITLE_ERROR]: 'Payment History Error',
  // Helmet Page Titles Payments
  [IDS.HELMET_PAYMENTS_PAGETITLE_ERROR]: 'Error',
  // Helmet Section Titles
  [IDS.HELMET_SECTIONTITLE_DASHBOARD]: 'Dashboard',
  [IDS.HELMET_SECTIONTITLE_PAYMENTS]: 'Payments',
  [IDS.HELMET_SECTIONTITLE_SPLASH]: 'Make a Payment',
  // Payments Home
  [IDS.HOME_CARD_LOAN]: 'Loan',
  // Payments Splash
  [IDS.SPLASHPAGE_AUTOPAY_BUTTON_LABEL]: 'Set Up Autopay',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT]: 'Ability to remit additional principal funds with every automatic payment.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ELIMINATESRISKS]: 'Eliminates risks associated with lost or delayed mail.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ENVIRONMENTALLYFRIENDLY]: 'Environmentally friendly. No paper!',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS]: 'Mortgage payments will be made on time.',
  [IDS.SPLASHPAGE_AUTOPAY_TITLE]: 'Autopay is a convenient and reliable way to make payments',
  [IDS.SPLASHPAGE_FLEXDRAFT_TEXT_ABILITYTOREMIT]: 'Ability to remit additional principal funds with every automatic payment.',
  [IDS.SPLASHPAGE_FLEXDRAFT_TEXT_DESIGNATEUPTO]: 'Designate up to 2 financial accounts for drafting.',
  [IDS.SPLASHPAGE_FLEXDRAFT_TEXT_MORTGAGEPAYMENTS]: 'Mortgage payments will be made on time in multiple installments.',
};

const enMurabahaMessages = {
  ...enMessages,
  // Payments Home
  [IDS.HOME_CARD_LOAN]: 'Account',
  // Payments Splash
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_ABILITYTOREMIT]: 'Ability to remit additional Murabaha payment funds with every automatic payment.',
  [IDS.SPLASHPAGE_AUTOPAY_TEXT_MORTGAGEPAYMENTS]: 'Murabaha Financing Transaction payments will be made on time.',
  [IDS.SPLASHPAGE_FLEXDRAFT_TEXT_ABILITYTOREMIT]: 'Ability to remit additional Murabaha payment funds with every automatic payment.',
  [IDS.SPLASHPAGE_FLEXDRAFT_TEXT_MORTGAGEPAYMENTS]: 'Murabaha Financing Transaction payments will be made on time in multiple installments.',

};

export const INTL_IDS = IDS;

export default {
  [LANGUAGE_ENGLISH]: enMessages,
  [LANGUAGE_ENGLISH_MURABAHA]: enMurabahaMessages,
};
